import axios, { AxiosInstance } from 'axios';
import { Endpoints } from '../endpoints';

export interface GetUserInfoRequest {}

export interface GetUserInfoResponse {
  firstName: string;
  lastName: string;
  username: string;
}

/**
 * Get app users info.
 * @param instance - Axios instance that will be used to query the API.
 */
export const getUserInfo = async (instance: AxiosInstance = axios) => {
  return instance.get<GetUserInfoResponse>(Endpoints.User.INFO);
};

export interface UpdateUsernameRequest {
  username: string;
  accessToken: string;
}
export interface UpdateUsernameResponse {}

/**
 * Update username. The username must be unique and will return a validation error if the specified username is already taken.
 * @param data.username The new username
 * @param data.accessToken The users cognito access token.
 * @param instance - Axios instance that will be used to query the API.
 */
export const updateUsername = async (
  data: UpdateUsernameRequest,
  instance: AxiosInstance = axios,
) => instance.post<UpdateUsernameResponse>(Endpoints.User.UPDATE_USERNAME, data);

export interface SetPasswordRequest {
  accessToken: string;
  oldPass: string;
  newPass: string;
  newPasswordConfirm: string;
}
export interface SetPasswordResponse {}

/**
 * Not yet implemented - C2-4427
 * This is currently just a forced OK response.
 * @param params
 * @param instance - Axios instance that will be used to query the API.
 * @returns
 */
export const setPassword = async (params: SetPasswordRequest, instance: AxiosInstance = axios) => {
  return instance.post<SetPasswordResponse>(Endpoints.User.CHANGE_PASSWORD, params);
};
